const services = [
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
          d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Web Applications',
    description: 'Full-stack web apps and business websites built with React and Node.js. Fast, scalable, and tailored to your business needs.',
    tags: ['React', 'Node.js', 'REST APIs', 'PostgreSQL'],
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
          d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Mobile Apps',
    description: 'Native and cross-platform mobile applications for iOS and Android. Clean UX with native performance.',
    tags: ['iOS', 'Android', 'Swift', 'Kotlin'],
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
          d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
      </svg>
    ),
    title: 'Enterprise & Desktop',
    description: 'Robust business applications using Blazor and C#. Ideal for internal tools, dashboards, and enterprise-grade solutions.',
    tags: ['Blazor', 'C#', '.NET', 'Azure'],
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
          d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    ),
    title: 'AI Integration',
    description: 'Add intelligence to your product — chatbots, automation, content generation, and smart features powered by the latest AI models.',
    tags: ['OpenAI', 'Claude API', 'Automations', 'LLMs'],
  },
];

export default function Services() {
  return (
    <section id="services" className="py-28 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="mb-16">
          <span className="text-xs font-medium tracking-widest text-violet-400 uppercase">What I Do</span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-3">Services</h2>
          <p className="text-gray-400 mt-4 max-w-xl">
            From idea to launch — I cover the full spectrum of digital product development.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {services.map((s) => (
            <div key={s.title}
              className="bg-white/[0.03] border border-white/[0.07] rounded-2xl p-8 hover:border-violet-500/30 transition-colors group">
              <div className="text-violet-400 mb-5 group-hover:text-violet-300 transition-colors">
                {s.icon}
              </div>
              <h3 className="text-white font-semibold text-lg mb-3">{s.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-5">{s.description}</p>
              <div className="flex flex-wrap gap-2">
                {s.tags.map(tag => (
                  <span key={tag} className="text-xs text-gray-500 border border-white/[0.06] bg-white/[0.03] px-3 py-1 rounded-full">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
